module.exports = __webpack_public_path__ + "static/media/datasheet_entData_row2_startplaying.078b5ec3.png";